import { render } from "./LeaderboardCell.vue?vue&type=template&id=64b99f48&scoped=true"
import script from "./LeaderboardCell.vue?vue&type=script&lang=js"
export * from "./LeaderboardCell.vue?vue&type=script&lang=js"

import "./LeaderboardCell.vue?vue&type=style&index=0&id=64b99f48&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b99f48"]])

export default __exports__